export const CREATE_PERSONAL_DETAIL = "CREATE_PERSONAL_DETAIL";
export const FETCH_PERSONAL_DETAIL = "FETCH_PERSONAL_DETAIL";
export const FETCH_PERSONAL_DETAILS = "FETCH_PERSONAL_DETAILS";
export const EDIT_PERSONAL_DETAIL = "EDIT_PERSONAL_DETAIL";
export const DELETE_PERSONAL_DETAIL = "DELETE_PERSONAL_DETAIL";
